/**
 * 判断是否HTML元素
 * @return {Boolean} 是否HTML元素
 */
var isElement = function (o) {
  return o instanceof Element || o instanceof HTMLDocument;
};
export default isElement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/esm/is-element.js
// module id = 93
// module chunks = 0